class VideoCard extends HTMLElement {
  static PLAY_ICON = `
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
      <path d="M0 5.6819V3.30856C0 0.361896 2.08667 -0.84477 4.64 0.628563L6.7 1.81523L8.76 3.0019C11.3133 4.47523 11.3133 6.88856 8.76 8.3619L6.7 9.54856L4.64 10.7352C2.08667 12.2086 0 11.0019 0 8.05523V5.6819Z" fill="white"/>
    </svg>
  </span>`;

  static PAUSE_ICON = `
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
      <rect x="0" y="0" width="3.5" height="12" rx="1" fill="white"/>
      <rect x="7.5" y="0" width="3.5" height="12" rx="1" fill="white"/>
    </svg>
  </span>`;

  /** @type {VideoCard | null} Last played video-card instance */
  static lastPlayed = null;

  connectedCallback() {
    if (this._boundToggle) return;

    const video = this.querySelector('video');
    const button = this.querySelector('.video-card__play');
    if (!video || !button) return;

    this._playButton = button;
    this._boundToggle = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    };
    button.addEventListener('click', this._boundToggle);
  }

  disconnectedCallback() {
    if (this._playButton && this._boundToggle) {
      this._playButton.removeEventListener('click', this._boundToggle);
      this._playButton = null;
      this._boundToggle = null;
    }
    if (VideoCard.lastPlayed === this) {
      const video = this.querySelector('video');
      const button = this.querySelector('.video-card__play');
      if (video) video.pause();
      if (button) button.innerHTML = VideoCard.PLAY_ICON;
      VideoCard.lastPlayed = null;
    }
  }

  toggle() {
    const video = this.querySelector('video');
    const button = this.querySelector('.video-card__play');
    if (!video || !button) return;

    if (video.paused) {
      const prev = VideoCard.lastPlayed;
      if (prev && prev !== this) {
        const prevVideo = prev.querySelector('video');
        const prevButton = prev.querySelector('.video-card__play');
        if (prevVideo) prevVideo.pause();
        if (prevButton) prevButton.innerHTML = VideoCard.PLAY_ICON;
      }

      const playPromise = video.play();
      if (typeof playPromise?.catch === 'function') {
        playPromise.catch((error) => {
          // Swiper/lazy-video can immediately pause during slide transitions.
          // Treat interrupted play requests as a non-fatal race.
          if (error?.name !== 'AbortError') {
            console.error('VideoCard: play() failed', error);
          }
          button.innerHTML = VideoCard.PLAY_ICON;
          if (VideoCard.lastPlayed === this) VideoCard.lastPlayed = null;
        });
      }
      button.innerHTML = VideoCard.PAUSE_ICON;
      VideoCard.lastPlayed = this;

      document.querySelectorAll('video').forEach((v) => {
        if (v === video) return;
        const blockRoot = v.closest('.speedo-video-block-optimized');
        if (blockRoot) {
          v.pause();
          const playBtn = blockRoot.querySelector('.speedo-video-block-optimized__play');
          const pauseBtn = blockRoot.querySelector('.speedo-video-block-optimized__pause');
          if (playBtn) playBtn.style.display = 'inline-flex';
          if (pauseBtn) pauseBtn.style.display = 'none';
        }
      });
    } else {
      video.pause();
      button.innerHTML = VideoCard.PLAY_ICON;
      if (VideoCard.lastPlayed === this) VideoCard.lastPlayed = null;
    }

    document.dispatchEvent(
      new CustomEvent('video-card-played', {
        detail: { video, button },
      })
    );
  }
}

if (!customElements.get('video-card')) {
  customElements.define('video-card', VideoCard);
}